var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_3310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.8131 17 0 13.1868 0 8.49995C0 3.81305 3.8131 2.30968e-07 8.5 2.30968e-07C13.1869 2.30968e-07 17 3.81305 17 8.49995C17 13.1868 13.1869 17 8.5 17ZM8.5 1.54545C4.66521 1.54545 1.54545 4.66521 1.54545 8.49995C1.54545 12.3347 4.66521 15.4545 8.5 15.4545C12.3348 15.4545 15.4545 12.3347 15.4545 8.49995C15.4545 4.66521 12.3347 1.54545 8.5 1.54545Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49988 13.3939C7.93188 13.3939 7.46979 12.9315 7.46979 12.3632C7.46979 11.7953 7.93188 11.3333 8.49988 11.3333C9.06789 11.3333 9.52998 11.7953 9.52998 12.3632C9.52998 12.9315 9.06789 13.3939 8.49988 13.3939Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 9.78784C8.07324 9.78784 7.72726 9.44187 7.72726 9.01511V4.37875C7.72726 3.952 8.07324 3.60602 8.49999 3.60602C8.92674 3.60602 9.27272 3.952 9.27272 4.37875V9.01511C9.27272 9.44187 8.92674 9.78784 8.49999 9.78784Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_3310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.5e77a217f7db3f017d306dcc9f356b2c.svg";
export { ForwardRef as ReactComponent };